import styled from '@emotion/styled';
import { Image } from '../../../../../../../ui/index.ts';

export const StepImage = styled(Image)`
  width: 270px;
  height: 300px;
`;
